import { Icon } from "@weirgroup/weir-dls"
import { useTranslation } from "react-i18next";
import { ShoppingListItem } from "../../../types/shopping-list.type";
import "../styles.scss"
import { useDarkMode } from "../../../hooks/use-darkmode";
interface Props {
    cardData: ShoppingListItem
    deleteItemHandler: any
    editHandler: (item: ShoppingListItem) => void
    isGuest: boolean;
    setIsQuantityModalShown: (value: boolean) => void
}

export const ShoppingListCard = (props: Props) => {
    const {
        cardData,
        deleteItemHandler,
        editHandler,
        isGuest,
        setIsQuantityModalShown
    } = props;
    const { t } = useTranslation();
    const {darkMode} = useDarkMode();
    return (
        <div className="shopping-list-card-container">
            <div className="color-status red-status-bg"></div>
            <div className="details">
                <div className="header">
                    <div className="title">
                        <p style={{color: darkMode ? "white" : "black"}}>{cardData.part.description}</p>
                    </div>
                    <div className="sub-details font-color-black">
                        <p style={{color: darkMode ? "white" : "black"}}>{t("quantity")}: <span>{cardData.quantity}</span></p>
                    </div>
                </div>
                <div className="card-body">
                    <div className="card-detail-flex font-color-gray">
                        <p className="category " style={{color: darkMode ? "white" : "gray"}}>{t("partNumber")}: <span style={{color: darkMode ? "white" : "gray"}}>{cardData?.part.part_number}</span></p>
                        <p className="category" style={{color: darkMode ? "white" : "gray"}}>{t("pmid")}: <span style={{color: darkMode ? "white" : "gray"}}>{cardData?.part.pmid}</span></p>
                    </div>
                    <div className="icons action-btn-flex">
                        <div
                            className={isGuest ? "isGuest btn-container" : "btn-container"}
                            onClick={() => {
                                setIsQuantityModalShown(true)
                                editHandler(cardData)
                            }}
                            role="button"
                        >
                            <Icon name={"Edit"} darkMode={darkMode}/>
                        </div>
                        <div
                            className={isGuest ? "isGuest btn-container" : "btn-container"}
                            onClick={() => deleteItemHandler(false, cardData?.shopping_cart_item_id)}
                            role="button"
                        >
                            <Icon name={"Trash"} darkMode={darkMode} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}